var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "104px",
    viewBox: "0 0 104 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4BBB3E4F-EF2F-4A1D-A5EF-8688DD2063F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 42,
    cy: 42,
    r: 42
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.9%",
    y: "-17.9%",
    width: "135.7%",
    height: "135.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0523374331 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Reset-Password-Success",
    transform: "translate(-1180.000000, -344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mark",
    transform: "translate(1190.000000, 354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.2804978,26.3722647 C55.0177717,28.3432132 52.937594,30.4233909 50.8571556,32.5766271 C48.8134093,34.7301239 46.8060294,36.9197915 44.8717079,39.1825175 C42.0249705,42.576574 39.2877231,46.1168777 36.7329588,49.766541 L27.4628142,39.8029603 C27.0249328,39.3284259 26.2950523,39.1825501 25.711041,39.54736 C25.0175398,39.948836 24.7986251,40.8248725 25.2001011,41.5180478 C25.2001011,41.5180478 34.0322862,56.7371436 34.3972525,57.394083 C34.7623231,58.0144932 35.5652751,59 37.2075584,59 C38.8134754,59 39.6891991,58.0511527 40.2004126,57.0656785 C40.7477578,56.0437728 45.638476,46.9926079 48.8136179,42.211549 C50.3828428,39.8027061 52.0981845,37.4669216 53.8135914,35.167699 C55.5653646,32.8683459 57.3901962,30.6056199 59.2516548,28.4888152 L59.2880595,28.4524105 C59.7623398,27.8320003 59.7623398,27.0290418 59.287805,26.481462 C58.7769379,25.8977303 57.864509,25.824926 57.2804978,26.3722647 Z",
    id: "Path",
    fill: "#023B93",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkIcon);
export default __webpack_public_path__ + "static/media/mark-icon.8cb2b2c1de219c65cc7237b7cad4779b.svg";
export { ForwardRef as ReactComponent };